console.log("js/navigation.js -> v0.1.5");

document.addEventListener("DOMContentLoaded", function () {
	function hasTargetClass(parent, className) {
		return parent.classList.contains(className);
	}

	const parentElements = document.querySelectorAll("[id='tag-row']");
	const seoDestinationSections = [];
	const seoCategorySections = [];
	let seoTitleText = "";
	let seoCategoryTitleText = "";

	parentElements.forEach((parent) => {
		if (hasTargetClass(parent, "seo_destination")) {
			const titleElement = parent.querySelector(".seo-section-title");
			if (titleElement && !seoTitleText) {
				seoTitleText = titleElement.textContent.trim();
			}
			if (titleElement) titleElement.remove();
			seoDestinationSections.push(parent);
		} else if (hasTargetClass(parent, "seo_category")) {
			const titleElement = parent.querySelector(".seo-section-title");
			if (titleElement && !seoCategoryTitleText) {
				seoCategoryTitleText = titleElement.textContent.trim();
			}
			if (titleElement) titleElement.remove();
			seoCategorySections.push(parent);
		}
	});

	const footerElement = document.getElementById("footer-links");

	if (footerElement) {
		let wrapperDiv = null;

		if (seoDestinationSections.length > 0 || seoTitleText) {
			wrapperDiv = document.createElement("div");
			wrapperDiv.id = "destination-seo-wrapper";

			if (seoTitleText) {
				const h1Element = document.createElement("h3");
				h1Element.insertAdjacentHTML("afterbegin", seoTitleText);
				wrapperDiv.appendChild(h1Element);
			}

			const innerWrapper = document.createElement("div");
			innerWrapper.id = "destination-seo-links";

			seoDestinationSections.forEach((section) => {
				innerWrapper.appendChild(section);
			});

			wrapperDiv.appendChild(innerWrapper);
			footerElement.after(wrapperDiv);
		}

		if (seoCategorySections.length > 0) {
			const categoryWrapper = document.createElement("div");
			categoryWrapper.id = "category-seo-links";

			seoCategorySections.forEach((section) => {
				categoryWrapper.appendChild(section);
			});

			if (wrapperDiv) {
				wrapperDiv.after(categoryWrapper);
			} else {
				footerElement.after(categoryWrapper);
			}

			if (seoCategoryTitleText) {
				const h1Element = document.createElement("h3");
				h1Element.className = 'category-seo-title';
				h1Element.textContent = seoCategoryTitleText;
				categoryWrapper.before(h1Element);
			}
		}
	}
});

document.addEventListener("DOMContentLoaded", function () {
	const expertContent = document.getElementById("expert-content");
	if (expertContent && expertContent.innerHTML.trim() === "") {
		expertContent.remove();
	}

	const seoContent = document.getElementById("seo-content-wrapper");
	if (seoContent) {
		const layoutWrapper = seoContent.querySelector(
			".customer-layout-wrapper"
		);
		if (layoutWrapper && layoutWrapper.innerHTML.trim() === "") {
			seoContent.remove();
		}
	}
});

const navigation = (() => {
	function initNavigation() {
		const logo = document.querySelector(".js-ll");
		if (logo) {
			logo.addEventListener("click", () => {
				window.location.href = "/";
			});
		}

		const icnBtns = document.querySelectorAll("a.icon-button");
		if (icnBtns.length) {
			icnBtns.forEach(btn => {
				btn.addEventListener("click", e => {
					const url = btn.getAttribute("href");
					if (url && !url.startsWith("#")) {
						e.preventDefault();
						btn.classList.contains("social-icon") ? window.open(url, "_blank") : window.location.href = url;
					}
				});
			});
		}

	if (document.querySelector(".trip-menu")) {
		const mainNavigationItemsList = document.querySelectorAll(".main_nav");
		const mainNavigationItems = [].slice.call(mainNavigationItemsList);

		const tripMenuTrigger = document.querySelector(".trip-menu-trigger");
		const userMenuTrigger = document.querySelector(".user-menu-trigger");
		const userMenu = document.querySelector(".user-menu");
		const closeUserMenuTrigger = document.querySelector(".close-user-menu");
		const closeTripMenuTrigger = document.querySelector(".close-trip-menu");
		const tripMenu = document.querySelector(".trip-menu");
		const tripBar = document.querySelector(".trip-bar");
		const mobileMenuHeader = document.querySelector(
			".trip-menu header .header-background"
		);
		const mobileMenuHeaderV1 = document.querySelector(".trip-menu header");
		let mobileMenuTitle = document.querySelector(
			".menu-header--title__text"
		);
		let lvl = tripMenu.dataset.currentLvl;
		let lvlMenuHeading = {
			0: "Explore",
		};

	let deviceType = "";
	let dragging = false;
	let isMobile = false;
	let preloadedImages = false;

	// Function to load flag images from data-src to src
	function loadFlagImages(rootSelector) {
		const root = rootSelector ? document.querySelector(rootSelector) : document;
		if (!root) {
			return;
		}
		const flagImages = root.querySelectorAll('img.lazy-flag[data-src]');
		flagImages.forEach(function(img) {
			if (img.dataset.src) {
				img.src = img.dataset.src;
				img.removeAttribute('data-src');
			}
		});
	}

	if (tripMenuTrigger) {
			tripMenuTrigger.addEventListener("click", function () {
				if (document.body.classList.contains("has-open-main-menu")) {
					document.body.classList.remove("has-open-main-menu");
					isMobile = false;
				} else {
					deviceType = "touch-mobile";
					isMobile = true;
					document.body.classList.add("has-open-main-menu");
				}
			});
		}

		window.addEventListener("resize", function (event) {

			if (
				document.body.classList.contains("has-open-user-menu") &&
				window.innerWidth > 768
			) {
				positionUserMenu();
			}
		});

			/**
			 * Close the trip menu through the trip menu trigger (touch devices)
			 */
			const handleCloseTripMenu = (event) => {
				event?.preventDefault();
				closeMainNavigation();

				while (lvl > 0) {
					lvlUp();
				}

				document.body.classList.remove("has-open-main-menu");
			};

			if (closeTripMenuTrigger) {
				closeTripMenuTrigger.addEventListener("click", handleCloseTripMenu);
			}
			if (!document.__ebsCloseTripMenuDelegated) {
				document.__ebsCloseTripMenuDelegated = true;
				document.addEventListener(
					"click",
					(event) => {
						const trigger = event.target?.closest?.(".close-trip-menu");
						if (!trigger) {
							return;
						}
						handleCloseTripMenu(event);
					},
					true
				);
			}

		window.addEventListener("popstate", function () {
			if (document.body.classList.contains("has-open-main-menu")) {
				closeMainNavigation();
				while (lvl > 0) {
					lvlUp();
				}

				document.body.classList.remove("has-open-main-menu");
			}

			if (document.body.classList.contains("has-open-user-menu")) {
				document.body.classList.remove("has-open-user-menu");
			}
		});

		window.addEventListener("DOMContentLoaded", function () {
			if (document.body.classList.contains("has-open-main-menu")) {
				closeMainNavigation();
				while (lvl > 0) {
					lvlUp();
				}

				document.body.classList.remove("has-open-main-menu");
			}

			if (document.body.classList.contains("has-open-user-menu")) {
				document.body.classList.remove("has-open-user-menu");
			}
		});

		/**
		 * user menu toggle
		 */

	userMenuTrigger.addEventListener("click", function () {
		if (document.body.classList.contains("has-open-user-menu")) {
			document.body.classList.remove("has-open-user-menu");
		} else {
			if (window.innerWidth > 768) {
				positionUserMenu();
			}
			document.body.classList.add("has-open-user-menu");

			// Load flag images immediately and with retries for mobile
			loadFlagImages('.user-menu');
			setTimeout(function() {
				loadFlagImages('.user-menu');
			}, 50);
			setTimeout(function() {
				loadFlagImages('.user-menu');
			}, 150);
			setTimeout(function() {
				loadFlagImages('.user-menu');
			}, 300);
		}
		if (userMenuTrigger.classList.contains("user-menu-trigger-bttn")) {
			document
				.querySelector(".user-menu--old")
				.classList.add("hidden");
		}

		if (
			userMenuTrigger.classList.contains("user-menu-trigger-bttn") &&
			userMenuTrigger.classList.contains("logged-in")
		) {
			document
				.querySelector(".user-menu--old")
				.classList.remove("hidden");
		}
	});

	// Add MutationObserver to watch for user menu visibility changes
	if (userMenu) {
		const userMenuObserver = new MutationObserver(function() {
			if (document.body.classList.contains('has-open-user-menu')) {
				// Try loading images when menu becomes visible
				setTimeout(function() {
					loadFlagImages('.user-menu');
				}, 10);
			}
		});
		userMenuObserver.observe(document.body, {
			attributes: true,
			attributeFilter: ['class']
		});
	}

		/* close the user menu when navigation away from any item in the user menu on the mobile version */
		let loginButton = document.querySelector(".user-menu .button__login");
		let signupButton = document.querySelector(".user-menu .button__signup");
		let currencyLanguageSwitcher = document.querySelector(
			".user-menu .currency-language-switcher"
		);

		if (loginButton) {
			loginButton.addEventListener("click", closeUserMenu);
		}

		if (signupButton) {
			signupButton.addEventListener("click", closeUserMenu);
		}

		if (currencyLanguageSwitcher) {
			currencyLanguageSwitcher.addEventListener("click", closeUserMenu);
		}

		/**
		 * Close the user menu event handler
		 */
		if (closeUserMenuTrigger) {
			closeUserMenuTrigger.addEventListener("click", (e) => {
				e.preventDefault();
				closeUserMenu();
			});
		}
		if (!document._closeUserMenuDelegated) {
			document._closeUserMenuDelegated = true;
			document.addEventListener(
				"click",
				(event) => {
					const trigger = event.target?.closest?.(".close-user-menu");
					if (!trigger) {
						return;
					}
					event.preventDefault();
					closeUserMenu();
				},
				true
			);
		}

		/**
		 * Mouse over events
		 */
		document.addEventListener("mouseover", function (event) {
			if (!isMobile) {
				deviceType = "mouse";
			}

			// when hovering over the submenu items, switch to the correct subnavigation section
			if (event.target?.classList.contains("link-type-group")) {
				subNavigation(event.target.dataset.parentGroup);
			}
		});

		mainNavigationItems.forEach((item) => {
			item.addEventListener("mouseover", function (event) {
				openMainNavigation(event.target);
			});
		});

		/**
		 * We should close the tripMenu when we hover off the tripMenu element, or when hovering
		 * off the main menu navigation items, without hovering over the tripMenu.
		 */

		document.addEventListener('mouseover', function(event) {
			let openNavigation = document.body.classList.contains('navigation-open');
			const tripBar = event.target?.classList.contains('trip-bar');
			const topBar = event.target?.classList.contains('top-bar');
			const mainNav = event.target?.classList.contains('main_nav');

			if (openNavigation) {
				if (topBar || (tripBar && !mainNav)) {
					closeMainNavigation();
				}
			}
		});

		/**
		 * Add event listener to the main navigation popout menu
		 * When mouse leaves the area it will close
		 */

		tripMenu.addEventListener("mouseleave", closeMainNavigation);

		/**
		 * add a global dragging state, when the touchmove event is fired we don't want to trigger navigation
		 */

		document.addEventListener("touchmove", function () {
			dragging = true;
		});

		/**
		 * When there is a touchstart event we reset the dragging value to false;
		 */
		document.addEventListener("touchstart", function () {
			dragging = false;
			deviceType = !isMobile ? "touch-large" : "touch-mobile";
		});

		/**
		 * Navigation up and down the navigation (touch devices)
		 */

		document.addEventListener("touchend", function (event) {
			let openNavigation =
				document.body.classList.contains("navigation-open");
			let target = event.target;

			if (dragging) {
				return;
			}

			if (openNavigation && !isInParent(event, "trip-menu")) {
				closeMainNavigation();
			}

			if (target.classList.contains("main_nav")) {
				isMobile = false;
				openMainNavigation(target);
			}

			if (
				target.classList.contains("link-type-group") &&
				deviceType === "touch-large"
			) {
				subNavigation(target.dataset.parentGroup);
			}

			if (deviceType === "touch-mobile") {
				if (target.classList.contains("lvl--primary")) {
					openMainNavigation(target);
				}

				if (target.classList.contains("lvl")) {
					lvlDeeper(event);

					if (target.dataset.parentGroup) {
						subNavigation(target.dataset.parentGroup);
					}
				}

				if (target.classList.contains("lvl-back")) {
					lvlUp();
				}

				if (target.classList.contains("to-page")) {
					if (target.getAttribute("href")) {
						loader.create(target, true, "medium", "", true);
						gae(
							"navigation",
							`navigation_link_${target.pathname.replace(
								/\//g,
								"_"
							)}`
						);
					} else {
						event.preventDefault();
					}
				}
			}
		});

		/**
		 * Position the user menu correctly when it is opened.
		 */

		function positionUserMenu() {
			let positionUserMenuTrigger =
				userMenuTrigger.getBoundingClientRect();
			userMenu.style.right =
				document.body.clientWidth -
				positionUserMenuTrigger.right -
				6 +
				"px";
		}


		/**
		 * Toggle the subnavigation and show hide children based on the current selection
		 * @param {String} parentGroup
		 */

		function subNavigation(parentGroup) {
			const currentItem = document.querySelector(
				`[data-parent-group="${parentGroup}"]`
			);
			const subItems = document.querySelectorAll("[data-parent]");
			const items = document.querySelectorAll(".link-type-group");

			toggleSubNavigation(subItems, items, parentGroup);
			currentItem.classList.add("active");
		}

		/**
		 * Loops through the different NodeLists to show or hide them based on the parent selection
		 * @param {NodeList} subItems
		 * @param {NodeList} items
		 */

		function toggleSubNavigation(subItems, items, parentGroup) {
			const cookieConsentBanner = document.querySelector(".cc-window");

			if (
				cookieConsentBanner &&
				cookieConsentBanner.style.display !== "none" &&
				!parentGroup
			) {
				return;
			}

			for (let i = 0; i < subItems.length; i++) {
				if (subItems[i].dataset.parent === parentGroup) {
					subItems[i].style.display = "block";
				} else {
					subItems[i].style.display = "none";
				}
			}

			disableOtherItems(items);
		}

		/**
		 * Open the main navigation for the desktop variant
		 * @param {Object} activeElement
		 */
		function openMainNavigation(activeElement) {
			const mainNavigationItems = document.querySelectorAll(
				".main-primary-links .main_nav"
			);
			const menuType = activeElement.dataset.menuType;

			disableOtherItems(mainNavigationItems);

			if (!isMobile) {
				setTripMenuPosition(tripMenu);
			}

			activeElement.classList.add("active");
			tripMenu.classList.add("active");
			tripMenu.dataset.menuType = menuType;
			document.body.classList.add("navigation-open");

			if (deviceType != "touch-mobile") {
				openFirstItem(menuType);
			}
			setupMenuVisibilityObserver(tripMenu);
		}

		function setupMenuVisibilityObserver(menu) {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						closeDropdown();
					}
				});
			});

			observer.observe(menu);
		}

		function closeDropdown() {
			const activeElement = document.querySelector(
				".main-primary-links .main_nav.active"
			);
			const tripMenu = document.querySelector(".trip-menu.active");

			if (activeElement) {
				activeElement.classList.remove("active");
			}

			if (tripMenu) {
				tripMenu.classList.remove("active");
				document.body.classList.remove("navigation-open");
			}
		}

		/**
		 *
		 * @param {String} menuType
		 */
		function openFirstItem(menuType) {
			const item = document.querySelector(
				".bucket.type-" + menuType + " .lvl"
			);
			const parentGroup = item.dataset.parentGroup;

			subNavigation(parentGroup);
		}

		/**
		 * Close the main navigation for the desktop variant
		 */

		function closeMainNavigation(noTransition) {
			if (noTransition) {
				tripMenu.style.transition = "none";
			}

			tripMenu.classList.remove("active");
			const mainNavigationItems = document.querySelectorAll(
				".main-primary-links .main_nav"
			);
			const subItems = document.querySelectorAll("[data-parent]");
			const items = document.querySelectorAll(".link-type-group");

			disableOtherItems(mainNavigationItems);
			toggleSubNavigation(subItems, items);
			document.body.classList.remove("navigation-open");
		}

		/**
		 * Close the user menu
		 */

		function closeUserMenu() {
			document.body.classList.remove("has-open-user-menu");
		}

		/**
		 * Remove active class for other items in the array
		 * @param {Array} items
		 */

		function disableOtherItems(items) {
			for (i = 0; i < items.length; i++) {
				items[i].classList.remove("active");
			}
		}

		/**
		 * Go a lvl deeper
		 * set global lvl counter plus 1
		 * move the current lvl out of the way
		 * set the navigation pane title
		 * @param {Object} event
		 */

		function lvlDeeper(event) {
			let containerCurrent = document.querySelector(`.lvl-${lvl}`);
			moveOut(containerCurrent);
			lvl++;
			lvlMenuHeading[lvl] = event.target.dataset.menuTitle;
			tripMenu.dataset.currentLvl = lvl;
			setNavigationPaneHeader(event.target.dataset.photoUrlMobile);
			lvl > 0 ? mobileMenuHeaderV1.classList.add("white-bg") : null;
		}

		/**
		 * Go a lvl up
		 * set global lvl counter minus 1
		 * move the previous lvl back into view
		 * run the disableOtherItems function to remove classes from the previous lvl (active classes are applied)
		 *
		 */

		function lvlUp() {
			const items = document.querySelectorAll(".lvl--primary");
			lvl--;
			setNavigationPaneHeader();
			tripMenu.dataset.currentLvl = lvl;
			let containerPrevious = document.querySelector(`.lvl-${lvl}`);
			disableOtherItems(items);
			moveIn(containerPrevious);
			lvl < 1 ? mobileMenuHeaderV1.classList.remove("white-bg") : null;
		}

		/**
		 * add the move-out class to the target
		 * @param {String} target
		 */

		function moveOut(target) {
			target.classList.add("move-out");
		}

		/**
		 * remove the move-out class from the target
		 * @param {String} target
		 */

		function moveIn(target) {
			target.classList.remove("move-out");
		}

		/**
		 * Set the navigation pane title with the value of the selected item
		 * We save the value in a global object so we keep the path the user navigates
		 */

		function setNavigationPaneHeader(url) {
			mobileMenuTitle.innerHTML = lvlMenuHeading[lvl];

			// if (url && mobileMenuHeader) {
			// 	mobileMenuHeader?.style.backgroundImage = `url(${url})`;
			// }
			// else if (lvl == 0 && mobileMenuHeader) {
			// 	mobileMenuHeader?.style.backgroundImage = '';
			// }
		}

		/**
		 * Event Listener that checks if the user menu is open and if there is a click outside of the element so to close it
		 */

		// Add focus event listener for inputs to close trip menu on mobile
		document.addEventListener("focus", function (event) {
			const openMainMenu = document.body.classList.contains("has-open-main-menu");
			const isInputFocus = event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT';
			const isJumbotronFormInput = event.target ?? event.target.closest('.jumbotron-form') !== null;
			
			if (openMainMenu && isInputFocus && isJumbotronFormInput && isMobile) {
				closeMainNavigation();
				while (lvl > 0) {
					lvlUp();
				}
				document.body.classList.remove("has-open-main-menu");
			}
		}, true); // Use capture phase to catch the event early

		document.addEventListener("click", function (event) {
			const containsTrigger =
				event.target.classList.contains("user-menu-trigger");
			const openUserMenu =
				document.body.classList.contains("has-open-user-menu");

			if (containsTrigger === false && openUserMenu) {
				if (isInParent(event, "user-menu") == false) {
					document.body.classList.remove("has-open-user-menu");
				}
			}

			// Mobile-only: Close trip menu when clicking outside of it
			const openMainMenu = document.body.classList.contains("has-open-main-menu");
			const containsTripMenuTrigger = event.target.classList.contains("trip-menu-trigger");
			
			if (openMainMenu && !containsTripMenuTrigger && isMobile) {
				if (isInParent(event, "trip-menu") == false) {
					closeMainNavigation();
					while (lvl > 0) {
						lvlUp();
					}
					document.body.classList.remove("has-open-main-menu");
				}
			}

			if (event.target.classList.contains("to-page")) {
				if (event.target.dataset.automated) {
					// automated link, from the destinations table
					gae(
						"navigation-automated-destination",
						event.target.dataset.id
					);
				} else {
					// manual menu item
					gae("navigation-manual-item", event.target.dataset.id);
				}

				closeMainNavigation(true);

				while (lvl > 0) {
					lvlUp();
				}

				document.body.classList.remove("has-open-main-menu");
			}
		});

		/**
		 * Checks if the container (specified class) is not a parent element
		 * @param {Object} event
		 * @param {String} container
		 */

		function isInParent(event, container) {
			let e = event.target;
			while (e) {
				if (e.classList.contains(container)) {
					return true;
				}
				e = e.parentElement;
			}
			return false;
		}

		/**
		 * Will preload the images for the Main Navigation when there is intent to look in the navigation
		 */

		function preloadNavigationImages() {
			if (preloadedImages) {
				return;
			}

			let images = [];
			let urls = [];

			let photoElementsList =
				document.querySelectorAll("a[data-photo-url]");
			let photoElements = [].slice.call(photoElementsList);

			let imagesUrls = photoElements.filter((element) => {
				return element.dataset.photoUrl != "";
			});

			/* loop through the elements and push the urls into an array */
			for (let i = 0; i < imagesUrls.length; i++) {
				urls.push(imagesUrls[i].dataset.photoUrl);
			}

			/* create a new array and call the Image() constructor */
			function preload() {
				for (let i = 0; i < preload.arguments.length; i++) {
					images[i] = new Image();
					images[i].src = preload.arguments[i];
				}
				preloadedImages = true;
			}

			/* spread the array items so it will use every item as an argument instead of the whole array */
			preload(...urls);
		}


		function setTripMenuPosition(menu) {
			const tripBarDimensions = tripBar.getBoundingClientRect();

			if (document.body.classList.contains("navigation-open")) {
				menu.style.top = tripBarDimensions.bottom + "px";
			}
		}
	}
	} // End of initNavigation function

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initNavigation);
	} else {
		initNavigation();
	}

	// document.querySelectorAll('.menu-container').forEach(function(container) {
	//     container.addEventListener('click', function(event) {
	//         if (event.target.closest('.lvl--primary')) {
	//             var header = container.querySelector('header[role="menu-header"]');
	//             if (header) {
	//                 var h2Element = header.querySelector('h2');
	//                 updateHeaderBackground(h2Element, header);
	//             }
	//         }
	//     });

	//     var backButton = container.querySelector('.lvl-back');
	//     if (backButton) {
	//         backButton.addEventListener('click', function() {
	//             var header = container.querySelector('header[role="menu-header"]');
	//             if (header) {
	//                 var h2Element = header.querySelector('h2');
	//                 updateHeaderBackground(h2Element, header);
	//             }
	//         });
	//     }
	// });

	// function updateHeaderBackground(h2Element, header) {
	//     if (h2Element.textContent.trim() === 'Menu') {
	//         header.style.backgroundColor = '#078372'; // Change to desired color
	//         var closeButton = header.querySelector('.close svg');
	//         if (closeButton) {
	//             closeButton.style.fill = 'white';
	//         }

	//         // Change the color of the lvl-back button
	//         var lvlBackButton = header.querySelector('.lvl-back svg');
	//         if (lvlBackButton) {
	//             lvlBackButton.style.fill = 'white';
	//         }
	//         h2Element.style.color = 'white';
	//     } else {
	//         header.style.backgroundColor = 'white'; // Change to desired color
	//         var closeButton = header.querySelector('.close svg');
	//         if (closeButton) {
	//             closeButton.style.fill = 'black';
	//         }

	//         // Change the color of the lvl-back button
	//         var lvlBackButton = header.querySelector('.lvl-back svg');
	//         if (lvlBackButton) {
	//             lvlBackButton.style.fill = 'black';
	//         }
	//         h2Element.style.color = '#2A3735';
	//     }
	// }

	/**
	 * Add a loading class when switching the language or the currency
	 */

	document.addEventListener("click", function (event) {
		if (event.target.classList.contains("lang-currency-switch")) {
			event.target.classList.add("is-loading");
		}

		if (event.target.classList.contains("language-change-button")) {
			window.location.href = event.target.dataset.urlWithParam;
		}

		if (event.target.classList.contains("redirect-banner-close")) {
			let redirectFromValue = document.querySelector(
				"#redirect-from-value"
			).value;

			if (redirectFromValue == "1") {
				document
					.querySelector(".redirect-banner-container-bma")
					.classList.add("hidden");
				sessionStorage.setItem("bma-redirect-banner-shown", true);
			}
			if (redirectFromValue == "2") {
				document
					.querySelector(".redirect-banner-container-bcv")
					.classList.add("hidden");
				sessionStorage.setItem("bcv-redirect-banner-shown", true);
			}
			if (redirectFromValue == "5") {
				document
					.querySelector(".redirect-banner-container-bch")
					.classList.add("hidden");
				sessionStorage.setItem("bch-redirect-banner-shown", true);
			}
			if (redirectFromValue == "9") {
				document
					.querySelector(".redirect-banner-container-bmr")
					.classList.add("hidden");
				sessionStorage.setItem("bmr-redirect-banner-shown", true);
			}
			if (redirectFromValue == "11") {
				document
					.querySelector(".redirect-banner-container-bdr")
					.classList.add("hidden");
				sessionStorage.setItem("bdr-redirect-banner-shown", true);
			}
			if (redirectFromValue == "14") {
				document
					.querySelector(".redirect-banner-container-bmt")
					.classList.add("hidden");
				sessionStorage.setItem("bmt-redirect-banner-shown", true);
			}

			document
				.querySelector(".user-menu")
				.classList.remove("bmr-redirect");
		}

		if (event.target.classList.contains("rediect-banner-popup")) {
			let deviceTypeMobile = document.querySelector(
				"#redirect-device-type"
			).value;
			let align = "";
			if (deviceTypeMobile == "true") {
				align = "bottom";
			} else {
				align = "center";
			}
			const siteName = event.target.dataset.site;
			const description = event.target.dataset.text;
			const bannerPopupBody = navigation.createRedirectBannerPopupBody(
				deviceTypeMobile == "true" ? "bottom" : "center",
				event.target.dataset.site,
				event.target.dataset.text
			);
			modals.create("", bannerPopupBody, "");
		}

		if (
			event.target.classList.contains("redirect-banner-continue") ||
			event.target.classList.contains("modal-backdrop-light") ||
			event.target.classList.contains("close")
		) {
			if (typeof modals !== "undefined") {
				modals.destroy(event.target);
			}
		}
	});

	document.addEventListener("DOMContentLoaded", function (event) {
		let redirectFromValue = document.querySelector("#redirect-from-value");

		if (redirectFromValue && !!redirectFromValue.value) {
			navigation.initRedirectionsBanner(redirectFromValue.value);
		}

		function loadFlagImages(rootSelector) {
			const root = rootSelector ? document.querySelector(rootSelector) : document;
			if (!root) {
				return;
			}
			const flagImages = root.querySelectorAll('img.lazy-flag[data-src]');
			flagImages.forEach(function(img) {
				if (img.dataset.src) {
					img.src = img.dataset.src;
					img.removeAttribute('data-src');
				}
			});
		}

		const langCurrencyModal = document.querySelector('#lang-currency-switch-combined-modal');
		if (langCurrencyModal) {
			if (typeof $ !== 'undefined' && $.fn.modal) {
				$(langCurrencyModal).on('shown.bs.modal', function() {
					loadFlagImages('#lang-currency-switch-combined-modal');
				});
			}

			const modalTriggers = document.querySelectorAll('a[href="#lang-currency-switch-combined-modal"]');
			modalTriggers.forEach(function(trigger) {
				trigger.addEventListener('click', function() {
					// Small delay to ensure modal is shown
					setTimeout(function () {
						loadFlagImages('#lang-currency-switch-combined-modal');
					}, 100);
				});
			});

			const observer = new MutationObserver(function(mutations) {
				const modal = document.querySelector('#lang-currency-switch-combined-modal');
				if (modal && modal.style.display !== 'none' && !modal.classList.contains('hidden') && modal.offsetParent !== null) {
					loadFlagImages('#lang-currency-switch-combined-modal');
					// Don't disconnect, in case modal is opened multiple times
				}
			});
			observer.observe(langCurrencyModal, { 
				attributes: true, 
				attributeFilter: ['style', 'class'] 
			});
		}

		const loginBtn = document.querySelector('.user-login-trigger-wrapper');
		if (loginBtn) {
			navigation.initLoginBtn(loginBtn);
		}
	});
	return {
		createRedirectBannerPopupBody: (align, siteName, description) => {
			let logo = `<h3 class="redirect-banner-popup-heading">${siteName} is now<span>Tripaneer</span></h3>`;
			if (align == "center") {
				logo = `<h3 class="redirect-banner-popup-heading">${siteName} is now</h3><svg width="87" height="21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66.907 8.826c-.21-1.462-.813-2.492-1.808-3.11a5.026 5.026 0 00-2.7-.69 8.5 8.5 0 00-1.152.083c-1.555.213-2.712.804-3.486 1.771a4.137 4.137 0 00-.938 2.652c0 .24.018.478.053.715l.415 2.907c.201 1.402.764 2.445 1.689 3.141.8.553 1.766.828 2.745.78a9.202 9.202 0 001.243-.09 5.698 5.698 0 003.303-1.441c.312-.288.56-.635.729-1.02a3 3 0 00.252-1.221c0-.174-.013-.348-.038-.52a.215.215 0 00-.076-.15.299.299 0 00-.187-.05.763.763 0 00-.104.008l-2.372.325a.502.502 0 00-.397.326c-.136.288-.35.535-.618.715-.268.179-.58.283-.905.302-.142.02-.286.03-.43.031a1.8 1.8 0 01-1.016-.273 1.412 1.412 0 01-.435-.43 1.378 1.378 0 01-.208-.57l-.026-.18a1.154 1.154 0 01-.012-.163.576.576 0 01.133-.4.625.625 0 01.393-.184l5.087-.697a1.168 1.168 0 00.818-.473c.152-.211.233-.464.23-.723-.001-.074-.006-.148-.017-.221l-.165-1.15zm-3.314.952a.65.65 0 01-.408.19l-2.486.34a.903.903 0 01-.123.01.515.515 0 01-.377-.143.702.702 0 01-.175-.406 1.58 1.58 0 01-.016-.226c.004-.377.144-.74.395-1.027.312-.38.763-.625 1.257-.682a2.68 2.68 0 01.364-.026c.358-.006.71.09 1.012.276.192.123.353.287.471.479s.19.407.212.63c.009.056.013.113.013.17a.597.597 0 01-.139.415zM43.745 8.607c0-1.29-.439-2.243-1.316-2.882-.877-.64-2.204-.966-3.982-.965a9.425 9.425 0 00-2.53.35 4.182 4.182 0 00-1.896.996.27.27 0 00-.056.196.313.313 0 00.042.14l.959 1.877a.22.22 0 00.19.114.413.413 0 00.211-.063c.384-.255.812-.44 1.263-.546a5.85 5.85 0 011.505-.213 5.625 5.625 0 011.7.202c.19.056.357.169.477.323a.887.887 0 01.161.542.741.741 0 01-.122.389.765.765 0 01-.312.27h-.002c-.226.115-.466.201-.713.258-.356.097-.833.207-1.43.33l-1.247.257c-.391.091-.77.226-1.13.403-.381.171-.73.406-1.028.694-.289.31-.513.67-.66 1.064a4.112 4.112 0 00-.273 1.555 2.78 2.78 0 00.648 1.868c.395.483.918.851 1.512 1.065.6.205 1.23.307 1.866.302 1.354 0 2.406-.273 3.16-.812l.002-.001a.745.745 0 01.369-.15.318.318 0 01.24.088c.058.07.087.16.081.25a.225.225 0 00.07.186c.068.047.15.07.233.063h1.681a.29.29 0 00.248-.078.277.277 0 00.08-.242v-7.83zm-3.272 3.956c0 .767-.206 1.318-.635 1.634a2.407 2.407 0 01-1.463.463 1.657 1.657 0 01-1.007-.32 1.094 1.094 0 01-.34-.409 1.07 1.07 0 01-.104-.516 1.444 1.444 0 01.125-.63.94.94 0 01.394-.417c.144-.084.296-.153.454-.206.128-.04.304-.091.527-.155h.003l1.61-.377.012-.002a.412.412 0 01.318.12.49.49 0 01.106.34v.475zm37.47-.05a.182.182 0 00-.07-.161.4.4 0 00-.238-.057H75.42a.464.464 0 00-.403.247 1.654 1.654 0 01-.661.578c-.27.131-.571.188-.871.165a1.896 1.896 0 01-1.296-.405 1.272 1.272 0 01-.46-1v-.168a.67.67 0 01.143-.463.547.547 0 01.43-.16h4.752a1.079 1.079 0 00.808-.33c.214-.227.328-.527.317-.836V8.849c0-1.365-.418-2.383-1.248-3.072-.833-.692-1.979-1.04-3.446-1.04-1.452 0-2.588.396-3.422 1.184-.41.382-.732.844-.948 1.356a3.883 3.883 0 00-.304 1.615v2.715a4.132 4.132 0 00.248 1.656c.195.53.496 1.017.886 1.43.752.75 1.935 1.131 3.561 1.131a5.295 5.295 0 003.213-.904c.39-.272.706-.634.92-1.054.213-.42.318-.885.304-1.354zm-5.68-4.768c.336-.31.782-.477 1.243-.467.447-.019.885.125 1.231.402.16.137.287.308.37.5.084.19.122.398.112.606a.691.691 0 01-.149.48.57.57 0 01-.445.166h-2.323a.547.547 0 01-.413-.15.612.612 0 01-.139-.433c0-.209.046-.416.134-.606.089-.19.218-.36.379-.498zm14.1-.612l-.961-.077a3.997 3.997 0 00-.315-.013 2.036 2.036 0 00-1.456.493 2.206 2.206 0 00-.593 1.467l-.518 6.261c0 .081-.031.16-.085.22a.285.285 0 01-.21.069l-.049-.003-2.553-.202a.347.347 0 01-.224-.083.276.276 0 01-.07-.205l.002-.048.886-10.711c0-.075.03-.147.082-.201a.294.294 0 01.207-.064l.053.002 1.593.126c.077 0 .152.025.215.068a.178.178 0 01.062.147l-.001.028-.008.092v.03a.228.228 0 00.08.184.373.373 0 00.213.073h.014a.54.54 0 00.232-.08 7.696 7.696 0 013.653-.581c.076 0 .15.029.205.08.048.057.071.13.065.203l-.002.052-.2 2.408a.306.306 0 01-.078.203.264.264 0 01-.193.064l-.046-.002zm-34.49 7.841a.28.28 0 01-.069-.208v-.025l.283-6.606c.002-.036.002-.071.002-.106.01-.39-.107-.771-.335-1.09l-.046.033.046-.033a1.439 1.439 0 00-.526-.405 1.469 1.469 0 00-.657-.128 2.685 2.685 0 00-.11-.002 1.58 1.58 0 00-1.156.42 1.638 1.638 0 00-.48 1.133l-.284 6.65a.309.309 0 01-.077.217.288.288 0 01-.212.068h-.027l-2.45-.1a.323.323 0 01-.222-.076.28.28 0 01-.07-.208l.001-.025.44-10.285a.271.271 0 01.074-.199.302.302 0 01.212-.063h.028l1.53.063a.337.337 0 01.208.063.2.2 0 01.062.16v.018l-.001.025c-.005.08.021.16.074.222a.3.3 0 00.217.086h.013a.687.687 0 00.365-.15 4.178 4.178 0 012.339-.66c.074 0 .149 0 .224.004 1.305.053 2.273.419 2.917 1.089.643.67.97 1.653.97 2.959 0 .116-.003.235-.008.356l-.286 6.696a.308.308 0 01-.077.216.29.29 0 01-.213.068h-.026l-2.451-.101a.323.323 0 01-.221-.076zm-33.618 1.738a.271.271 0 01-.067-.201v-.017l.292-9.827a.269.269 0 01.066-.192.26.26 0 01.19-.06h.016l2.364.067a.304.304 0 01.212.07.27.27 0 01.067.202v.017l-.291 9.806a.29.29 0 01-.072.207.28.28 0 01-.206.066h-.017l-2.343-.067a.304.304 0 01-.211-.07zm-1.412-9.305a.22.22 0 01-.064.197.23.23 0 01-.202.063h-.881a2.104 2.104 0 00-1.508.49 1.962 1.962 0 00-.506 1.46v5.748a.238.238 0 01-.07.213.25.25 0 01-.217.068H11.05a.254.254 0 01-.217-.068.242.242 0 01-.07-.213V5.534a.248.248 0 01.069-.196.314.314 0 01.218-.064h1.463a.335.335 0 01.206.05.172.172 0 01.059.146v.085a.225.225 0 00.08.185.335.335 0 00.213.06.454.454 0 00.22-.09 7.054 7.054 0 013.285-.794.265.265 0 01.2.066.3.3 0 01.066.215v2.21zm4.452-5.401c.305.31.472.726.464 1.156v.06a1.603 1.603 0 01-.502 1.156 1.672 1.672 0 01-1.191.465h-.063a1.712 1.712 0 01-1.213-.514l-.041.039.04-.039a1.557 1.557 0 01-.464-1.145l.001-.06c.008-.44.192-.859.513-1.167a1.724 1.724 0 011.203-.475h.06a1.673 1.673 0 011.193.524zm4.223 18.421a.246.246 0 00.187-.064.306.306 0 00.069-.206l.182-4.439a.454.454 0 01.077-.261.258.258 0 01.216-.099h.016c.02.002.04.008.058.017.02.009.044.02.073.036.457.243.967.376 1.486.39.105.004.207.006.308.006a4.575 4.575 0 003.06-.975c.424-.377.76-.838.988-1.353.228-.514.341-1.07.333-1.63l.12-2.903c.002-.075.004-.15.004-.224a3.7 3.7 0 00-.25-1.48 3.76 3.76 0 00-.82-1.268 4.588 4.588 0 00-3.203-1.227 3.78 3.78 0 00-2.382.695.438.438 0 01-.258.086h-.017a.294.294 0 01-.21-.083.303.303 0 01-.071-.215v-.039a.186.186 0 00-.058-.152.318.318 0 00-.198-.06l-1.461-.057h-.024a.278.278 0 00-.201.064.291.291 0 00-.073.205l-.61 14.851v.022a.253.253 0 00.07.197c.064.05.145.077.227.074l2.341.092h.021zm.619-9.105l.09-2.188c-.001-.498.176-.98.499-1.364a1.616 1.616 0 011.265-.495c.037 0 .074 0 .113.002.247-.009.493.04.717.142.225.102.421.255.573.446.255.37.383.81.367 1.255l-.003.132-.09 2.187c.005.5-.172.983-.5 1.365-.162.164-.359.29-.576.373-.217.082-.45.116-.683.102l-.117-.003a1.604 1.604 0 01-.715-.138 1.57 1.57 0 01-.576-.44 2.03 2.03 0 01-.367-1.245c0-.043 0-.087.003-.131zm-17.09 6.325l.004.059-.004-.06c-.22.014-.437.02-.647.02a6.233 6.233 0 01-3.801-1.092c-1.115-.824-1.734-2.15-1.852-3.996L2.46 8.042a.566.566 0 00-.161-.394.58.58 0 00-.409-.135c-.022 0-.045 0-.068.002l-1.165.071-.052.002a.383.383 0 01-.27-.083.367.367 0 01-.101-.259L.089 4.991l-.001-.045A.328.328 0 01.172 4.7a.402.402 0 01.267-.096l1.219-.074a.59.59 0 00.402-.158.552.552 0 00.138-.4l-.003-.067-.173-2.733-.001-.023a.175.175 0 01.051-.14.28.28 0 01.175-.057L5.47.754l.033-.001a.233.233 0 01.16.047.204.204 0 01.058.146l.174 2.733c0 .152.057.3.162.412a.565.565 0 00.411.142c.022 0 .044 0 .066-.002l1.788-.109.046-.001a.349.349 0 01.253.082c.064.073.099.166.097.262l.14 2.202.002.053a.389.389 0 01-.091.282.414.414 0 01-.284.107l-1.788.109a.607.607 0 00-.403.152.525.525 0 00-.138.385l.002.061.255 4.006c-.002.699.222 1.38.64 1.947.198.222.445.397.723.511.277.114.578.165.878.148.07 0 .142-.002.215-.007l.04-.001a.313.313 0 01.235.082.403.403 0 01.094.263l.16 2.52.001.04a.295.295 0 01-.083.23.423.423 0 01-.27.091z" fill="#078372"><svg>`;
			}
			let body = `<section class="redirect-banner-popup-container">
							<div class="redirect-banner-popup-icon-container">
								<svg width="60" height="60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="30" fill="#EAFBF8"/><path d="M10.035 25.23c-.751 6.813 3.973 18.266 16.738 20.783 6.492 1.284 15.116-.493 19.38-9.527C60.225 6.669 11.827 7.583 10.034 25.23z" fill="#078372"/><path d="M35.202 42.004a.545.545 0 01-.388.148v.098-.099c-.315.025-.63.025-.92.025-2.229 0-4.046-.543-5.45-1.629-1.6-1.234-2.471-3.209-2.64-5.948l-.413-6.763a.81.81 0 00-.242-.593.735.735 0 00-.581-.197h-.097l-1.672.099h-.072c-.267.049-.485-.149-.533-.395v-.1L22 23.295v-.074c0-.123.024-.271.121-.37a.544.544 0 01.388-.148l1.744-.1a.78.78 0 00.581-.246.767.767 0 00.194-.592v-.099l-.242-4.073v-.024c0-.074.024-.148.072-.198.073-.05.17-.099.243-.074L29.727 17h.049c.072 0 .17.025.218.074.048.05.073.148.073.222l.242 4.073c0 .222.072.444.242.617.17.148.363.222.581.222h.097l2.568-.173h.073c.12 0 .266.025.363.124a.567.567 0 01.145.395l.194 3.282v.074a.655.655 0 01-.121.42c-.121.099-.267.173-.412.148l-2.568.173a.858.858 0 00-.58.222.713.713 0 00-.195.568v.099l.364 5.973c.072 1.283.387 2.246.92 2.912.533.667 1.308.988 2.301.988h.364c.12 0 .242.024.339.123a.567.567 0 01.145.395l.218 3.752v.049a.747.747 0 01-.145.272z" fill="#EAFBF8"/></svg>
							</div>
							<div class="redirect-banner-popup-content">
								${logo}
							</div>
							<p class="redirect-banner-popup-subheading">${description}</p>
							<button class="bttn -regular bttn-submit redirect-banner-continue">Continue</button>
						</section>`;
			return body;
		},

		initRedirectionsBanner: (site) => {
			const rdBanner = document.querySelector(".redirect-banner-close");
			const userMenu = document.querySelector(".user-menu");
			const bannerContainer = document.querySelector(
				`.redirect-banner-container.redirect-banner-container-${+site}`
			);
			const uMAddClass = +site == 15 ? "brv-redirect" : "bmr-redirect";
			const isIOS =
				/iPad|iPhone|iPod/.test(navigator.userAgent) &&
				!window.MSStream;

			if (
				bannerContainer &&
				bannerContainer.classList.contains("hidden")
			) {
				const toHide = isIOS
					? false
					: sessionStorage.getItem(`redirect-banner-shown-${site}`);
				if (!toHide) {
					bannerContainer.classList.remove("hidden");
					userMenu.classList.add(uMAddClass);
				}
			}

			rdBanner?.addEventListener("click", (ev) => {
				bannerContainer.classList.add("hidden");
				sessionStorage.setItem(`redirect-banner-shown-${site}`, true);
			});
		},

		initLoginBtn: (loginBtn) => {
			const {loginHref, signupHref, customerServiceHref, partnerHref} = loginBtn.dataset;
			const popup = `					
				<div id="toggleDiv">
					<a ${!!(loginHref) ? `href="${loginHref}"` : `href="#plt-login-modal" data-toggle="modal" onclick="navigationM.toggleModal(event)"`} class="login-btn cstm-btn">
						${navTranslation.login}
					</a>
					<a ${!!(signupHref) ? `href="${signupHref}"` : `href="#plt-signup-modal" data-toggle="modal" onclick="navigationM.toggleModal(event)"`} class="sign-up-btn cstm-btn" styel="text-transform: capitalize;">
						${navTranslation.createAccountBtn}
					</a>
					<a href="${customerServiceHref}" class="contact-support-link-toggle">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_1838_2116)">
						<path d="M14 23H19C20.657 23 22 21.657 22 20V17" stroke="#2A3735" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
						<path d="M7 12H2V17C2 18.1045 2.8955 19 4 19H7V12Z" stroke="#2A3735" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
						<path d="M22 12H17V19H20C21.1045 19 22 18.1045 22 17V12Z" stroke="#2A3735" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
						<path d="M22 12V11C22 5.477 17.523 1 12 1C6.477 1 2 5.477 2 11V12" stroke="#2A3735" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
						</g>
						<defs>
						<clipPath id="clip0_1838_2116">
						<rect width="24" height="24" fill="white"></rect>
						</clipPath>
						</defs>
						</svg> &nbsp;${navTranslation.contactSupport}
					</a>
					<div class="toggle-dropdown-divider"></div>
					<section class="user-menu-partners_section menu-container__user-menu partners">
						<a href="${partnerHref}" class="partner-link">
							<div class="partner-content">
								<div style="display: flex; align-items: center;">
									<span class="partner-icon">
										<svg xmlns="http://www.w3.org/2000/svg" width="25" height="15" viewBox="0 0 25 15" fill="none">
										<mask id="path-1-outside-1_1997_101" maskUnits="userSpaceOnUse" x="-0.5" y="-0.5" width="26" height="16" fill="black">
										<rect fill="white" x="-0.5" y="-0.5" width="26" height="16"></rect>
										<path d="M19.61 3.32047C19.6061 3.35828 19.5944 3.39409 19.5768 3.42991C19.5573 3.51348 19.5475 3.60899 19.5475 3.71445C19.5475 3.7244 19.5495 3.73435 19.5495 3.7443V10.6568C19.6354 10.8737 19.7408 11.0369 19.8678 11.1383C19.9849 11.2338 20.1294 11.2796 20.3052 11.2717C20.3169 11.2697 20.3306 11.2697 20.3423 11.2697H22.2873C22.2912 11.2697 22.297 11.2697 22.3029 11.2697C22.6056 11.2856 22.8243 11.202 22.9707 11.0309C23.1367 10.8359 23.2324 10.5235 23.2656 10.1036V10.0977L23.8573 3.86169C23.8573 3.85174 23.8573 3.84179 23.8593 3.83185C23.9003 3.47766 23.8241 3.24685 23.6523 3.11154C23.455 2.95634 23.1289 2.89267 22.7052 2.89267C22.6954 2.89267 22.6856 2.89466 22.6759 2.89466H20.4849V2.89267C20.1509 2.89267 19.9049 2.96032 19.7545 3.09961C19.692 3.15731 19.6452 3.23093 19.61 3.32047ZM17.4659 10.9672C17.419 10.9214 17.3858 10.8618 17.3721 10.7961L14.2477 5.06551C13.9001 4.47455 13.5876 4.46062 13.285 4.64368C13.0701 4.77301 12.8436 4.98393 12.6171 5.19485C12.4804 5.3222 12.3437 5.44954 12.2285 5.54704L11.6915 5.99872L11.6876 6.00071C11.297 6.32107 10.8557 6.49418 10.4378 6.528C10.1625 6.55188 9.89688 6.51607 9.65474 6.42255C9.40673 6.32704 9.18802 6.17382 9.02399 5.9649C8.84629 5.74005 8.72912 5.45352 8.70178 5.11526H8.70373C8.69788 5.03368 8.72131 4.9521 8.77599 4.88444L10.4827 2.81507C10.1234 2.8091 9.8051 2.85884 9.50633 2.95435C9.05133 3.09961 8.62562 3.35032 8.16086 3.67465C8.10814 3.71644 8.03979 3.74231 7.96754 3.74231H6.00109V7.52887L6.0089 9.95043H7.15323C7.26258 9.95043 7.36803 10.0081 7.42466 10.1116L8.84629 12.6366C9.05328 13.0048 9.23684 13.3231 9.46532 13.532C9.68012 13.729 9.96132 13.8504 10.3948 13.8624C10.5569 13.8663 10.7131 13.8385 10.8596 13.7768C10.9494 13.739 11.0393 13.6873 11.1271 13.6216L10.2054 11.8666C10.1234 11.7114 10.182 11.5184 10.3343 11.4368C10.4866 11.3532 10.676 11.4129 10.7561 11.5681L11.7579 13.4763C12.1309 13.6693 12.4687 13.729 12.7714 13.6634C13.0487 13.6017 13.3103 13.4326 13.5564 13.158L12.1133 10.8498C12.0215 10.7026 12.0625 10.5056 12.209 10.4101C12.3535 10.3166 12.5468 10.3583 12.6405 10.5076L14.1598 12.9391C14.4273 13.0505 14.6831 13.0744 14.9272 13.0067C15.1596 12.9411 15.394 12.7899 15.6263 12.5431L14.2496 9.90069C14.1676 9.74549 14.2262 9.55049 14.3805 9.46891C14.5328 9.38533 14.7242 9.44503 14.8042 9.60222L16.2297 12.3362C16.4153 12.4456 16.6301 12.4735 16.8351 12.4397C17.0148 12.4098 17.1886 12.3302 17.3311 12.2168C17.4678 12.1054 17.5752 11.9621 17.626 11.7989C17.6826 11.6219 17.6768 11.4149 17.585 11.1901L17.4659 10.9672ZM17.8798 10.4141H18.9226V3.7443C18.9226 3.73634 18.9226 3.72639 18.9246 3.71843C18.9246 3.61496 18.9304 3.51547 18.9441 3.42195L17.8818 2.70364C17.8759 2.69966 17.8701 2.69568 17.8642 2.6917C17.7256 2.59818 17.5596 2.47879 17.3936 2.35941C16.7902 1.92961 16.1712 1.48589 15.5014 1.30681C15.1401 1.20931 14.7222 1.14564 14.2965 1.13768C13.9235 1.12972 13.5447 1.16553 13.1873 1.26104C12.9745 1.31676 12.7675 1.39436 12.5761 1.49783C12.4062 1.58936 12.248 1.70079 12.1074 1.83609L11.3966 2.69767C11.3751 2.74144 11.3439 2.77726 11.3068 2.80711L9.3462 5.18689C9.37549 5.33811 9.43407 5.46546 9.51414 5.56893C9.60787 5.68633 9.73285 5.77388 9.8754 5.82959C10.0277 5.88729 10.2035 5.90918 10.387 5.89326C10.6858 5.8674 11.0061 5.74204 11.2931 5.50724L11.8301 5.05556C11.9668 4.94016 12.082 4.83271 12.1973 4.72725C12.4492 4.49245 12.6991 4.25965 12.9647 4.09848C13.5759 3.72639 14.1852 3.71445 14.7866 4.74317L14.7925 4.75312L17.8798 10.4141ZM19.0398 11.0528H18.206C18.3192 11.389 18.3134 11.7074 18.2235 11.99C18.1318 12.2805 17.9521 12.5272 17.7217 12.7142C17.4971 12.8953 17.2237 13.0207 16.9367 13.0684C16.6574 13.1162 16.3645 13.0903 16.0911 12.9749C15.7747 13.3112 15.4408 13.5241 15.0932 13.6216C14.7437 13.7191 14.3902 13.6992 14.0329 13.5718C13.6931 13.9559 13.3182 14.1966 12.9042 14.2862C12.4824 14.3797 12.0352 14.314 11.5607 14.0872C11.4122 14.2046 11.258 14.2981 11.0959 14.3658C10.8674 14.4633 10.6272 14.507 10.3753 14.4991C9.77386 14.4812 9.36963 14.3001 9.04742 14.0056C8.73888 13.7251 8.53384 13.3669 8.29951 12.953L6.96967 10.5892H5.9386C5.87806 10.8936 5.77457 11.1523 5.61834 11.3592C5.35472 11.7054 4.97002 11.8885 4.43496 11.8765C4.4291 11.8765 4.42324 11.8765 4.41738 11.8765H2.65012C2.20489 11.9502 1.82409 11.8387 1.52532 11.4865C1.25974 11.1742 1.08008 10.6668 1.00197 9.92258C1.00002 9.91462 1.00002 9.90467 0.998068 9.89472L0.533307 4.02485C0.441526 3.3921 0.54307 2.9444 0.793026 2.63797C1.04493 2.32956 1.42573 2.19027 1.89244 2.16839C1.90611 2.1664 1.91783 2.1664 1.9315 2.1664H4.31193V2.16839C4.76107 2.16242 5.14772 2.24002 5.44064 2.43303C5.67693 2.58823 5.84682 2.80711 5.93274 3.10557H7.87185C8.36005 2.77129 8.81504 2.50864 9.31886 2.34747C9.81487 2.19027 10.3441 2.13456 10.9787 2.21216L11.6329 1.42421C11.6446 1.40829 11.6563 1.39436 11.672 1.38043C11.8575 1.20135 12.0645 1.05411 12.2871 0.934719C12.5214 0.809363 12.7714 0.713853 13.033 0.644211C13.447 0.534772 13.8825 0.492987 14.3082 0.500946C14.7905 0.510895 15.2592 0.582527 15.6634 0.689976C16.4367 0.898903 17.1046 1.37446 17.7529 1.83808C17.8974 1.94155 18.0419 2.04502 18.2138 2.16043C18.2196 2.16441 18.2255 2.16839 18.2313 2.17237L19.1726 2.81308C19.2194 2.74542 19.2741 2.68374 19.3366 2.62803C19.6061 2.38129 19.9908 2.25992 20.4868 2.25992V2.25793H22.6778C22.6856 2.25793 22.6954 2.25793 22.7032 2.25992C23.2637 2.25793 23.7206 2.3614 24.037 2.61012C24.3885 2.8867 24.5544 3.30654 24.4841 3.90945C24.4841 3.91542 24.4822 3.9194 24.4822 3.92537L23.8905 10.1554C23.8475 10.7125 23.7011 11.1483 23.4433 11.4507C23.168 11.7731 22.7872 11.9323 22.2873 11.9104H20.3423H20.3403C20.0045 11.9283 19.7174 11.8348 19.4772 11.6398C19.3015 11.4945 19.155 11.2995 19.0398 11.0528ZM3.23595 8.63121C3.47029 8.63121 3.65971 8.82422 3.65971 9.06299C3.65971 9.30176 3.47029 9.49477 3.23595 9.49477C3.00162 9.49477 2.8122 9.30176 2.8122 9.06299C2.8122 8.82422 3.00162 8.63121 3.23595 8.63121ZM21.68 8.63121C21.9143 8.63121 22.1037 8.82422 22.1037 9.06299C22.1037 9.30176 21.9143 9.49477 21.68 9.49477C21.4456 9.49477 21.2562 9.30176 21.2562 9.06299C21.2562 8.82422 21.4456 8.63121 21.68 8.63121ZM5.37425 6.79265L5.36253 3.42394C5.36253 3.41797 5.36253 3.412 5.36253 3.40404C5.32933 3.19313 5.2395 3.05185 5.10672 2.9643C4.92511 2.84491 4.65367 2.79915 4.31975 2.80313H4.31584V2.80512H1.93345C1.92954 2.80512 1.92564 2.80512 1.92173 2.80512C1.62686 2.81905 1.40229 2.89068 1.27536 3.04588C1.13867 3.21103 1.0918 3.49756 1.15624 3.94128C1.1582 3.95123 1.1582 3.95919 1.1582 3.96914L1.62296 9.84498V9.85492C1.68545 10.4638 1.81433 10.8538 1.99594 11.0687C2.14044 11.2398 2.33767 11.2876 2.57396 11.2438C2.59154 11.2398 2.61106 11.2378 2.62864 11.2378V11.2358H4.41543C4.42715 11.2358 4.43886 11.2358 4.44863 11.2378C4.76498 11.2438 4.98369 11.1483 5.12038 10.9672C5.28051 10.7563 5.35862 10.426 5.37034 10.0002H5.36839V6.79265H5.37425Z"></path>
										</mask>
										<path d="M19.61 3.32047C19.6061 3.35828 19.5944 3.39409 19.5768 3.42991C19.5573 3.51348 19.5475 3.60899 19.5475 3.71445C19.5475 3.7244 19.5495 3.73435 19.5495 3.7443V10.6568C19.6354 10.8737 19.7408 11.0369 19.8678 11.1383C19.9849 11.2338 20.1294 11.2796 20.3052 11.2717C20.3169 11.2697 20.3306 11.2697 20.3423 11.2697H22.2873C22.2912 11.2697 22.297 11.2697 22.3029 11.2697C22.6056 11.2856 22.8243 11.202 22.9707 11.0309C23.1367 10.8359 23.2324 10.5235 23.2656 10.1036V10.0977L23.8573 3.86169C23.8573 3.85174 23.8573 3.84179 23.8593 3.83185C23.9003 3.47766 23.8241 3.24685 23.6523 3.11154C23.455 2.95634 23.1289 2.89267 22.7052 2.89267C22.6954 2.89267 22.6856 2.89466 22.6759 2.89466H20.4849V2.89267C20.1509 2.89267 19.9049 2.96032 19.7545 3.09961C19.692 3.15731 19.6452 3.23093 19.61 3.32047ZM17.4659 10.9672C17.419 10.9214 17.3858 10.8618 17.3721 10.7961L14.2477 5.06551C13.9001 4.47455 13.5876 4.46062 13.285 4.64368C13.0701 4.77301 12.8436 4.98393 12.6171 5.19485C12.4804 5.3222 12.3437 5.44954 12.2285 5.54704L11.6915 5.99872L11.6876 6.00071C11.297 6.32107 10.8557 6.49418 10.4378 6.528C10.1625 6.55188 9.89688 6.51607 9.65474 6.42255C9.40673 6.32704 9.18802 6.17382 9.02399 5.9649C8.84629 5.74005 8.72912 5.45352 8.70178 5.11526H8.70373C8.69788 5.03368 8.72131 4.9521 8.77599 4.88444L10.4827 2.81507C10.1234 2.8091 9.8051 2.85884 9.50633 2.95435C9.05133 3.09961 8.62562 3.35032 8.16086 3.67465C8.10814 3.71644 8.03979 3.74231 7.96754 3.74231H6.00109V7.52887L6.0089 9.95043H7.15323C7.26258 9.95043 7.36803 10.0081 7.42466 10.1116L8.84629 12.6366C9.05328 13.0048 9.23684 13.3231 9.46532 13.532C9.68012 13.729 9.96132 13.8504 10.3948 13.8624C10.5569 13.8663 10.7131 13.8385 10.8596 13.7768C10.9494 13.739 11.0393 13.6873 11.1271 13.6216L10.2054 11.8666C10.1234 11.7114 10.182 11.5184 10.3343 11.4368C10.4866 11.3532 10.676 11.4129 10.7561 11.5681L11.7579 13.4763C12.1309 13.6693 12.4687 13.729 12.7714 13.6634C13.0487 13.6017 13.3103 13.4326 13.5564 13.158L12.1133 10.8498C12.0215 10.7026 12.0625 10.5056 12.209 10.4101C12.3535 10.3166 12.5468 10.3583 12.6405 10.5076L14.1598 12.9391C14.4273 13.0505 14.6831 13.0744 14.9272 13.0067C15.1596 12.9411 15.394 12.7899 15.6263 12.5431L14.2496 9.90069C14.1676 9.74549 14.2262 9.55049 14.3805 9.46891C14.5328 9.38533 14.7242 9.44503 14.8042 9.60222L16.2297 12.3362C16.4153 12.4456 16.6301 12.4735 16.8351 12.4397C17.0148 12.4098 17.1886 12.3302 17.3311 12.2168C17.4678 12.1054 17.5752 11.9621 17.626 11.7989C17.6826 11.6219 17.6768 11.4149 17.585 11.1901L17.4659 10.9672ZM17.8798 10.4141H18.9226V3.7443C18.9226 3.73634 18.9226 3.72639 18.9246 3.71843C18.9246 3.61496 18.9304 3.51547 18.9441 3.42195L17.8818 2.70364C17.8759 2.69966 17.8701 2.69568 17.8642 2.6917C17.7256 2.59818 17.5596 2.47879 17.3936 2.35941C16.7902 1.92961 16.1712 1.48589 15.5014 1.30681C15.1401 1.20931 14.7222 1.14564 14.2965 1.13768C13.9235 1.12972 13.5447 1.16553 13.1873 1.26104C12.9745 1.31676 12.7675 1.39436 12.5761 1.49783C12.4062 1.58936 12.248 1.70079 12.1074 1.83609L11.3966 2.69767C11.3751 2.74144 11.3439 2.77726 11.3068 2.80711L9.3462 5.18689C9.37549 5.33811 9.43407 5.46546 9.51414 5.56893C9.60787 5.68633 9.73285 5.77388 9.8754 5.82959C10.0277 5.88729 10.2035 5.90918 10.387 5.89326C10.6858 5.8674 11.0061 5.74204 11.2931 5.50724L11.8301 5.05556C11.9668 4.94016 12.082 4.83271 12.1973 4.72725C12.4492 4.49245 12.6991 4.25965 12.9647 4.09848C13.5759 3.72639 14.1852 3.71445 14.7866 4.74317L14.7925 4.75312L17.8798 10.4141ZM19.0398 11.0528H18.206C18.3192 11.389 18.3134 11.7074 18.2235 11.99C18.1318 12.2805 17.9521 12.5272 17.7217 12.7142C17.4971 12.8953 17.2237 13.0207 16.9367 13.0684C16.6574 13.1162 16.3645 13.0903 16.0911 12.9749C15.7747 13.3112 15.4408 13.5241 15.0932 13.6216C14.7437 13.7191 14.3902 13.6992 14.0329 13.5718C13.6931 13.9559 13.3182 14.1966 12.9042 14.2862C12.4824 14.3797 12.0352 14.314 11.5607 14.0872C11.4122 14.2046 11.258 14.2981 11.0959 14.3658C10.8674 14.4633 10.6272 14.507 10.3753 14.4991C9.77386 14.4812 9.36963 14.3001 9.04742 14.0056C8.73888 13.7251 8.53384 13.3669 8.29951 12.953L6.96967 10.5892H5.9386C5.87806 10.8936 5.77457 11.1523 5.61834 11.3592C5.35472 11.7054 4.97002 11.8885 4.43496 11.8765C4.4291 11.8765 4.42324 11.8765 4.41738 11.8765H2.65012C2.20489 11.9502 1.82409 11.8387 1.52532 11.4865C1.25974 11.1742 1.08008 10.6668 1.00197 9.92258C1.00002 9.91462 1.00002 9.90467 0.998068 9.89472L0.533307 4.02485C0.441526 3.3921 0.54307 2.9444 0.793026 2.63797C1.04493 2.32956 1.42573 2.19027 1.89244 2.16839C1.90611 2.1664 1.91783 2.1664 1.9315 2.1664H4.31193V2.16839C4.76107 2.16242 5.14772 2.24002 5.44064 2.43303C5.67693 2.58823 5.84682 2.80711 5.93274 3.10557H7.87185C8.36005 2.77129 8.81504 2.50864 9.31886 2.34747C9.81487 2.19027 10.3441 2.13456 10.9787 2.21216L11.6329 1.42421C11.6446 1.40829 11.6563 1.39436 11.672 1.38043C11.8575 1.20135 12.0645 1.05411 12.2871 0.934719C12.5214 0.809363 12.7714 0.713853 13.033 0.644211C13.447 0.534772 13.8825 0.492987 14.3082 0.500946C14.7905 0.510895 15.2592 0.582527 15.6634 0.689976C16.4367 0.898903 17.1046 1.37446 17.7529 1.83808C17.8974 1.94155 18.0419 2.04502 18.2138 2.16043C18.2196 2.16441 18.2255 2.16839 18.2313 2.17237L19.1726 2.81308C19.2194 2.74542 19.2741 2.68374 19.3366 2.62803C19.6061 2.38129 19.9908 2.25992 20.4868 2.25992V2.25793H22.6778C22.6856 2.25793 22.6954 2.25793 22.7032 2.25992C23.2637 2.25793 23.7206 2.3614 24.037 2.61012C24.3885 2.8867 24.5544 3.30654 24.4841 3.90945C24.4841 3.91542 24.4822 3.9194 24.4822 3.92537L23.8905 10.1554C23.8475 10.7125 23.7011 11.1483 23.4433 11.4507C23.168 11.7731 22.7872 11.9323 22.2873 11.9104H20.3423H20.3403C20.0045 11.9283 19.7174 11.8348 19.4772 11.6398C19.3015 11.4945 19.155 11.2995 19.0398 11.0528ZM3.23595 8.63121C3.47029 8.63121 3.65971 8.82422 3.65971 9.06299C3.65971 9.30176 3.47029 9.49477 3.23595 9.49477C3.00162 9.49477 2.8122 9.30176 2.8122 9.06299C2.8122 8.82422 3.00162 8.63121 3.23595 8.63121ZM21.68 8.63121C21.9143 8.63121 22.1037 8.82422 22.1037 9.06299C22.1037 9.30176 21.9143 9.49477 21.68 9.49477C21.4456 9.49477 21.2562 9.30176 21.2562 9.06299C21.2562 8.82422 21.4456 8.63121 21.68 8.63121ZM5.37425 6.79265L5.36253 3.42394C5.36253 3.41797 5.36253 3.412 5.36253 3.40404C5.32933 3.19313 5.2395 3.05185 5.10672 2.9643C4.92511 2.84491 4.65367 2.79915 4.31975 2.80313H4.31584V2.80512H1.93345C1.92954 2.80512 1.92564 2.80512 1.92173 2.80512C1.62686 2.81905 1.40229 2.89068 1.27536 3.04588C1.13867 3.21103 1.0918 3.49756 1.15624 3.94128C1.1582 3.95123 1.1582 3.95919 1.1582 3.96914L1.62296 9.84498V9.85492C1.68545 10.4638 1.81433 10.8538 1.99594 11.0687C2.14044 11.2398 2.33767 11.2876 2.57396 11.2438C2.59154 11.2398 2.61106 11.2378 2.62864 11.2378V11.2358H4.41543C4.42715 11.2358 4.43886 11.2358 4.44863 11.2378C4.76498 11.2438 4.98369 11.1483 5.12038 10.9672C5.28051 10.7563 5.35862 10.426 5.37034 10.0002H5.36839V6.79265H5.37425Z" fill="#2A3735"></path>
										<path d="M19.61 3.32047C19.6061 3.35828 19.5944 3.39409 19.5768 3.42991C19.5573 3.51348 19.5475 3.60899 19.5475 3.71445C19.5475 3.7244 19.5495 3.73435 19.5495 3.7443V10.6568C19.6354 10.8737 19.7408 11.0369 19.8678 11.1383C19.9849 11.2338 20.1294 11.2796 20.3052 11.2717C20.3169 11.2697 20.3306 11.2697 20.3423 11.2697H22.2873C22.2912 11.2697 22.297 11.2697 22.3029 11.2697C22.6056 11.2856 22.8243 11.202 22.9707 11.0309C23.1367 10.8359 23.2324 10.5235 23.2656 10.1036V10.0977L23.8573 3.86169C23.8573 3.85174 23.8573 3.84179 23.8593 3.83185C23.9003 3.47766 23.8241 3.24685 23.6523 3.11154C23.455 2.95634 23.1289 2.89267 22.7052 2.89267C22.6954 2.89267 22.6856 2.89466 22.6759 2.89466H20.4849V2.89267C20.1509 2.89267 19.9049 2.96032 19.7545 3.09961C19.692 3.15731 19.6452 3.23093 19.61 3.32047ZM17.4659 10.9672C17.419 10.9214 17.3858 10.8618 17.3721 10.7961L14.2477 5.06551C13.9001 4.47455 13.5876 4.46062 13.285 4.64368C13.0701 4.77301 12.8436 4.98393 12.6171 5.19485C12.4804 5.3222 12.3437 5.44954 12.2285 5.54704L11.6915 5.99872L11.6876 6.00071C11.297 6.32107 10.8557 6.49418 10.4378 6.528C10.1625 6.55188 9.89688 6.51607 9.65474 6.42255C9.40673 6.32704 9.18802 6.17382 9.02399 5.9649C8.84629 5.74005 8.72912 5.45352 8.70178 5.11526H8.70373C8.69788 5.03368 8.72131 4.9521 8.77599 4.88444L10.4827 2.81507C10.1234 2.8091 9.8051 2.85884 9.50633 2.95435C9.05133 3.09961 8.62562 3.35032 8.16086 3.67465C8.10814 3.71644 8.03979 3.74231 7.96754 3.74231H6.00109V7.52887L6.0089 9.95043H7.15323C7.26258 9.95043 7.36803 10.0081 7.42466 10.1116L8.84629 12.6366C9.05328 13.0048 9.23684 13.3231 9.46532 13.532C9.68012 13.729 9.96132 13.8504 10.3948 13.8624C10.5569 13.8663 10.7131 13.8385 10.8596 13.7768C10.9494 13.739 11.0393 13.6873 11.1271 13.6216L10.2054 11.8666C10.1234 11.7114 10.182 11.5184 10.3343 11.4368C10.4866 11.3532 10.676 11.4129 10.7561 11.5681L11.7579 13.4763C12.1309 13.6693 12.4687 13.729 12.7714 13.6634C13.0487 13.6017 13.3103 13.4326 13.5564 13.158L12.1133 10.8498C12.0215 10.7026 12.0625 10.5056 12.209 10.4101C12.3535 10.3166 12.5468 10.3583 12.6405 10.5076L14.1598 12.9391C14.4273 13.0505 14.6831 13.0744 14.9272 13.0067C15.1596 12.9411 15.394 12.7899 15.6263 12.5431L14.2496 9.90069C14.1676 9.74549 14.2262 9.55049 14.3805 9.46891C14.5328 9.38533 14.7242 9.44503 14.8042 9.60222L16.2297 12.3362C16.4153 12.4456 16.6301 12.4735 16.8351 12.4397C17.0148 12.4098 17.1886 12.3302 17.3311 12.2168C17.4678 12.1054 17.5752 11.9621 17.626 11.7989C17.6826 11.6219 17.6768 11.4149 17.585 11.1901L17.4659 10.9672ZM17.8798 10.4141H18.9226V3.7443C18.9226 3.73634 18.9226 3.72639 18.9246 3.71843C18.9246 3.61496 18.9304 3.51547 18.9441 3.42195L17.8818 2.70364C17.8759 2.69966 17.8701 2.69568 17.8642 2.6917C17.7256 2.59818 17.5596 2.47879 17.3936 2.35941C16.7902 1.92961 16.1712 1.48589 15.5014 1.30681C15.1401 1.20931 14.7222 1.14564 14.2965 1.13768C13.9235 1.12972 13.5447 1.16553 13.1873 1.26104C12.9745 1.31676 12.7675 1.39436 12.5761 1.49783C12.4062 1.58936 12.248 1.70079 12.1074 1.83609L11.3966 2.69767C11.3751 2.74144 11.3439 2.77726 11.3068 2.80711L9.3462 5.18689C9.37549 5.33811 9.43407 5.46546 9.51414 5.56893C9.60787 5.68633 9.73285 5.77388 9.8754 5.82959C10.0277 5.88729 10.2035 5.90918 10.387 5.89326C10.6858 5.8674 11.0061 5.74204 11.2931 5.50724L11.8301 5.05556C11.9668 4.94016 12.082 4.83271 12.1973 4.72725C12.4492 4.49245 12.6991 4.25965 12.9647 4.09848C13.5759 3.72639 14.1852 3.71445 14.7866 4.74317L14.7925 4.75312L17.8798 10.4141ZM19.0398 11.0528H18.206C18.3192 11.389 18.3134 11.7074 18.2235 11.99C18.1318 12.2805 17.9521 12.5272 17.7217 12.7142C17.4971 12.8953 17.2237 13.0207 16.9367 13.0684C16.6574 13.1162 16.3645 13.0903 16.0911 12.9749C15.7747 13.3112 15.4408 13.5241 15.0932 13.6216C14.7437 13.7191 14.3902 13.6992 14.0329 13.5718C13.6931 13.9559 13.3182 14.1966 12.9042 14.2862C12.4824 14.3797 12.0352 14.314 11.5607 14.0872C11.4122 14.2046 11.258 14.2981 11.0959 14.3658C10.8674 14.4633 10.6272 14.507 10.3753 14.4991C9.77386 14.4812 9.36963 14.3001 9.04742 14.0056C8.73888 13.7251 8.53384 13.3669 8.29951 12.953L6.96967 10.5892H5.9386C5.87806 10.8936 5.77457 11.1523 5.61834 11.3592C5.35472 11.7054 4.97002 11.8885 4.43496 11.8765C4.4291 11.8765 4.42324 11.8765 4.41738 11.8765H2.65012C2.20489 11.9502 1.82409 11.8387 1.52532 11.4865C1.25974 11.1742 1.08008 10.6668 1.00197 9.92258C1.00002 9.91462 1.00002 9.90467 0.998068 9.89472L0.533307 4.02485C0.441526 3.3921 0.54307 2.9444 0.793026 2.63797C1.04493 2.32956 1.42573 2.19027 1.89244 2.16839C1.90611 2.1664 1.91783 2.1664 1.9315 2.1664H4.31193V2.16839C4.76107 2.16242 5.14772 2.24002 5.44064 2.43303C5.67693 2.58823 5.84682 2.80711 5.93274 3.10557H7.87185C8.36005 2.77129 8.81504 2.50864 9.31886 2.34747C9.81487 2.19027 10.3441 2.13456 10.9787 2.21216L11.6329 1.42421C11.6446 1.40829 11.6563 1.39436 11.672 1.38043C11.8575 1.20135 12.0645 1.05411 12.2871 0.934719C12.5214 0.809363 12.7714 0.713853 13.033 0.644211C13.447 0.534772 13.8825 0.492987 14.3082 0.500946C14.7905 0.510895 15.2592 0.582527 15.6634 0.689976C16.4367 0.898903 17.1046 1.37446 17.7529 1.83808C17.8974 1.94155 18.0419 2.04502 18.2138 2.16043C18.2196 2.16441 18.2255 2.16839 18.2313 2.17237L19.1726 2.81308C19.2194 2.74542 19.2741 2.68374 19.3366 2.62803C19.6061 2.38129 19.9908 2.25992 20.4868 2.25992V2.25793H22.6778C22.6856 2.25793 22.6954 2.25793 22.7032 2.25992C23.2637 2.25793 23.7206 2.3614 24.037 2.61012C24.3885 2.8867 24.5544 3.30654 24.4841 3.90945C24.4841 3.91542 24.4822 3.9194 24.4822 3.92537L23.8905 10.1554C23.8475 10.7125 23.7011 11.1483 23.4433 11.4507C23.168 11.7731 22.7872 11.9323 22.2873 11.9104H20.3423H20.3403C20.0045 11.9283 19.7174 11.8348 19.4772 11.6398C19.3015 11.4945 19.155 11.2995 19.0398 11.0528ZM3.23595 8.63121C3.47029 8.63121 3.65971 8.82422 3.65971 9.06299C3.65971 9.30176 3.47029 9.49477 3.23595 9.49477C3.00162 9.49477 2.8122 9.30176 2.8122 9.06299C2.8122 8.82422 3.00162 8.63121 3.23595 8.63121ZM21.68 8.63121C21.9143 8.63121 22.1037 8.82422 22.1037 9.06299C22.1037 9.30176 21.9143 9.49477 21.68 9.49477C21.4456 9.49477 21.2562 9.30176 21.2562 9.06299C21.2562 8.82422 21.4456 8.63121 21.68 8.63121ZM5.37425 6.79265L5.36253 3.42394C5.36253 3.41797 5.36253 3.412 5.36253 3.40404C5.32933 3.19313 5.2395 3.05185 5.10672 2.9643C4.92511 2.84491 4.65367 2.79915 4.31975 2.80313H4.31584V2.80512H1.93345C1.92954 2.80512 1.92564 2.80512 1.92173 2.80512C1.62686 2.81905 1.40229 2.89068 1.27536 3.04588C1.13867 3.21103 1.0918 3.49756 1.15624 3.94128C1.1582 3.95123 1.1582 3.95919 1.1582 3.96914L1.62296 9.84498V9.85492C1.68545 10.4638 1.81433 10.8538 1.99594 11.0687C2.14044 11.2398 2.33767 11.2876 2.57396 11.2438C2.59154 11.2398 2.61106 11.2378 2.62864 11.2378V11.2358H4.41543C4.42715 11.2358 4.43886 11.2358 4.44863 11.2378C4.76498 11.2438 4.98369 11.1483 5.12038 10.9672C5.28051 10.7563 5.35862 10.426 5.37034 10.0002H5.36839V6.79265H5.37425Z" stroke="#2A3735" mask="url(#path-1-outside-1_1997_101)"></path>
										</svg>
									</span>
									<div class="partner-title">${navTranslation.becomeAPartner}</div>
								</div>
								
								<div class="partner-text">
									
									<div class="partner-description">${navTranslation.loginInstructors}</div>
								</div>
							</div>
						</a>
					</section>
				</div>`;
				
			loginBtn.addEventListener('click', (ev) => {
				ev.stopPropagation();
				const toggleDiv = document.querySelector('#toggleDiv');

				if (!toggleDiv) {
					loginBtn.insertAdjacentHTML('beforeend', popup);
				} else {
					toggleDiv.classList.toggle('hide');
				}
			});

		},

	};
})();

window.navigationM = {
	toggleModal: (ev) => {
		ev.preventDefault();
		ev.stopPropagation();

		const p = ev.target.href.split('#');
		if (p.length > 1) {
			$(`#${p[1]}`).modal('show');
		}
	}
};
